import outputs from '../../amplify_outputs.json';

type AmplifyCustomOutputs = {
  apiBaseUrl: string;
};

export const amplifyCustom = outputs.custom as AmplifyCustomOutputs;
